export const EMAIL_SUPPORT_URL = 'mailto:support@ourpact.com'
export const FAQS_URL = 'https://support.ourpact.com/hc/categories/115002430347-FAQs'
export const PRIVACY_URL = 'https://ourpact.com/privacy'
export const SUPPORT_URL = 'https://support.ourpact.com'
export const TERMS_URL = 'https://ourpact.com/terms'
export const QUICK_PAIR_SUPPORT_URL =
	'https://support.ourpact.com/hc/en-us/articles/39299482283671-What-is-Quick-Pair-and-How-it-Works'
